import React from 'react'
import ImageDashboard from "./image-dashboard";

const Images = ({}) => {
    return (
        <>
            <ImageDashboard/>
        </>
    )
}

export default Images
